import Dialog from '@mui/material/Dialog'

const JobPostCancelRenewal = ({ jobPost, onSubmit, onClose }) => {
  return (
    <Dialog
      open={!!jobPost}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal-light',
      }}
    >
      <div className="w-full flex flex-col items-center">
        <h2 className="text-xl font-bold text-primary-100 text-center">
          Do You Want to Cancel this
          <br />
          Job Post Renewal?
        </h2>

        <button
          className="mt-[24px] h-[44px] w-full rounded-[8px] bg-primary-button hover:bg-primary-button-hover shadow-button flex items-center justify-center text-lg font-semibold text-white transition-colors duration-200 ease"
          onClick={onSubmit}
        >
          Yes, Cancel Auto-Renewal
        </button>

        <button
          className="mt-[8px] h-[44px] w-full rounded-[8px] border-[1px] border-primary-button bg-white hover:text-white hover:!bg-primary-button-hover shadow-button flex items-center justify-center text-base font-semibold text-primary-100 transition-colors duration-200 ease"
          onClick={onClose}
        >
          Back
        </button>
      </div>
    </Dialog>
  )
}

export default JobPostCancelRenewal
